import { css } from "@emotion/react";
import { queries } from "src/utils/media-queries";

export default {
  loading: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-family: proxima-nova, sans-serif;
  `,
  loadingAnimation: css`
    transform: scale(0.5);

    @media ${queries.xxLarge} {
      transform: scale(1);
    }
  `,
};
